import type { EaiwsSession } from '@easterngraphics/wcf/modules/eaiws/EaiwsSession';

import i18next from 'i18next';
import sortBy from 'lodash/sortBy';

import { GATEKEEPER_ID, SessionManager } from '../stores/AppStore';
import { errorMessageStore } from '../stores/ErrorMessageStore';
import { languageStore } from '../stores/LanguageStore';
import { SessionExpiredError } from '../utils/ErrorHandler';

import { EaiwsProvider } from '@egr/xbox/app-api/EaiwsProvider';
import { DATA_LANGUAGES } from '@egr/xbox/base-app/managers/SessionManager';
export const SessionWrapper: React.FC<React.PropsWithChildren> = (props) => {
    const { language } = languageStore.useState(['language']);
    function onSessionError(): void {
        errorMessageStore.open(new SessionExpiredError());
    }

    async function onSessionInit(session: EaiwsSession): Promise<void> {
        const languages = getSortedDataLanguages(language);
        await session.basket.setLanguages(languages);
    }

    return (
        <EaiwsProvider
            manager={SessionManager}
            gatekeeperIdCallback={async () => GATEKEEPER_ID}
            sessionExpiredCallback={onSessionError}
            sessionInitCallback={onSessionInit}
            skipSessionOnRender={true}
        >
            {props.children}
        </EaiwsProvider>
    );
};

function getSortedDataLanguages(primaryLanguage: string | null = null): Array<string> {
    let languages: ReadonlyArray<string> = i18next.languages;

    if (primaryLanguage != null) {
        languages = [primaryLanguage, ...languages];
    }

    return sortBy(DATA_LANGUAGES, (value: string): number => {
        const pos: number = languages.indexOf(value);
        if (pos === -1) {
            return languages.length + 1;
        }

        return pos;
    });
}
